/*
 * Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
enum RenderColors {
  PlannedPath = 'white',
  Leader = 'red',
  Follower = 'blue',
  Field = '#de0000',
  PartField = 'Cyan',
  Exclusion = 'Yellow',
  WorkArea = '#14cb5d',
  CropArea = 'orange'
}

export default RenderColors;
